var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "SPFPlayer-autoplay" }, [
    _c("span", { staticClass: "SPFPlayer-autoplayTitle" }, [
      _vm._v(_vm._s(_vm.autoplayTitle))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "SPFPlayer-autoplayCounter" }, [
      _c("span", [_vm._v(_vm._s(_vm.currentMedia))]),
      _vm._v("/"),
      _c("span", [_vm._v(_vm._s(_vm.mediasLength))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "SPFPlayer-autoplayToggle" }, [
      _c("label", { attrs: { for: "spfplayer-autoplay" } }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.autoplay,
              expression: "autoplay"
            }
          ],
          attrs: {
            type: "checkbox",
            name: "spfplayer-autoplay",
            id: "spfplayer-autoplay"
          },
          domProps: {
            checked: Array.isArray(_vm.autoplay)
              ? _vm._i(_vm.autoplay, null) > -1
              : _vm.autoplay
          },
          on: {
            change: function($event) {
              var $$a = _vm.autoplay,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.autoplay = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.autoplay = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.autoplay = $$c
              }
            }
          }
        }),
        _vm._v("\n      " + _vm._s(_vm.autoplayLabel) + "\n      "),
        _c("span")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }